"use client";

import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Heart, Sparkles, Users, Award } from "lucide-react";
export default function QueIncluyeLaExperiencia() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const features = [{
    icon: Heart,
    title: "Atención Personalizada",
    description: "Cuidado individualizado adaptado a tus necesidades específicas"
  }, {
    icon: Sparkles,
    title: "Experiencia Premium",
    description: "Detalles excepcionales que hacen la diferencia en cada momento"
  }, {
    icon: Users,
    title: "Equipo Profesional",
    description: "Expertos comprometidos con tu bienestar y satisfacción"
  }, {
    icon: Award,
    title: "Calidad Garantizada",
    description: "Estándares de excelencia en cada aspecto del servicio"
  }];
  const refs = [ref1, ref2, ref3, ref4];
  const visibilities = [isVisible1, isVisible2, isVisible3, isVisible4];
  return <section id="qué-incluye-la-experiencia" className="py-16 px-4 md:py-24 bg-muted">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Qué incluye la experiencia
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Descubre los elementos que hacen única nuestra propuesta
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full p-8 bg-background border border-border hover:border-accent hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group">
                  <div className="flex flex-col items-center text-center gap-4">
                    <div className="relative">
                      <Icon className="size-12 text-accent-dark transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105" strokeWidth={2} style={{
                    animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
                  }} />
                    </div>
                    <h3 className="text-xl md:text-2xl font-display font-semibold text-foreground">
                      {feature.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.7;
          }
        }
      `}</style>
    </section>;
}